import { createSelector } from 'reselect';

import type { RootState } from 'typesafe-actions';

import type { SearchAreasState } from './reducer';

export const getErrors = (state: RootState) => state.searchAreas.errors;

export const getSearchAreas = (state: RootState) => state.searchAreas;

export const getIsFetching = createSelector(
  getSearchAreas,
  (state: SearchAreasState) => state.isFetching,
);

export const getDepartureAreas = createSelector(
  getSearchAreas,
  (state: SearchAreasState) => state.departureAreas,
);

export const getPlacesOfStay = createSelector(
  getSearchAreas,
  (state: SearchAreasState) => state.placesOfStay,
);
